import { useCallback } from 'react';

import { useAddOpportunityStatsMutation } from '../api';
import { AddOpportunityStatsRequest } from '../api/types';
import { useCurrentUser } from '@/features/users/hooks';

export type useSendOpportunityStatsProps = {
  readonly type: string;
  readonly user?: string;
};

export function useSendOpportunityStats({ type }: useSendOpportunityStatsProps) {
  const [sendStats] = useAddOpportunityStatsMutation();
  const currentUser = useCurrentUser();

  return useCallback(
    (opportunityId: string) => {

      if (!currentUser?.id) return;

      sendStats({
        opportunity: opportunityId,
        key: type,
        user: currentUser.id,
      } as AddOpportunityStatsRequest);
    },
    [sendStats, type, currentUser?.id]
  );
}
